import React from 'react';
import * as yup from 'yup';

import {
  AttendeeFragment,
  InteractionDetails,
  InteractionForAttendeeFragment,
  InteractionFragment,
  InteractionValueType,
  MediaRefFragment,
  ProductHuntMedia,
  ProductHuntPromoInteractionDetails,
  PublicEWebinarFragment,
} from '$/GraphQL/schema/schema';
import { InteractionInfo, RibbonMedia } from '$/components/Interactions/InteractionInfo';
import {
  InteractionModalAccordionsHook,
  InteractionModalComponentProps,
} from '$/components/Interactions/types';
import type { IntegrationInfo } from '..';

import type { InteractionModalTitleProps } from '$/components/Interactions/types';
import { NoBodyCard, ProductHuntPromoCard } from './ProductHuntPromoCard';

import { AnalyticsCardProps } from '$/components/Interactions/cards/types';
import { ProductHuntPromoIcon } from '$/images/FontAwesomeIcons';
import { ProductHuntPromoInteractionModalTitle } from './ProductHuntPromoInteractionModalTitle';
import { ProductHuntPromoInteractionValidationRules } from './ProductHuntPromoInteractionValidationRules';
import { useProductHuntPromoInteractionModalSettings } from './useProductHuntPromoInteractionModalSettings';

const ProductHuntPromoInteractionModal = React.lazy(
  () => import('./ProductHuntPromoInteractionModal')
);
const AnalyticsClickCard = React.lazy(
  () => import('$/components/Interactions/cards/AnalyticsClickCard')
);

export class ProductHuntPromoInteractionInfo extends InteractionInfo {
  constructor(
    i: InteractionForAttendeeFragment | InteractionFragment,
    integration?: IntegrationInfo,
    ewebinar?: PublicEWebinarFragment,
    attendee?: AttendeeFragment
  ) {
    super(i, ewebinar, attendee);
    this.integration = integration;
  }

  public detailsDefault(interactions: InteractionInfo[]): InteractionDetails {
    const defaults = super.detailsDefault(interactions);

    return {
      ...defaults,
      buttonText: 'Come support us!',
    };
  }

  public typeName(): string {
    return 'Product Hunt badge';
  }

  public title(): string {
    return this.i.details?.title ?? '';
  }

  public description(): string {
    return this.i.details?.description ?? '';
  }

  public hasAnswers(): boolean {
    return true;
  }

  public valueType(): InteractionValueType {
    return InteractionValueType.Action;
  }

  public icon(): React.FC {
    return ProductHuntPromoIcon;

    /*
    const integration = this.fragment.details?.integration as
      | ProductHuntPromoInteractionDetails
      | undefined;
    const url = integration?.post?.thumbnail.url;

    return url
      ? styled((props) => {
          return <img {...props} src={url} />;
        })``
      : ProductHuntPromoIcon;
    */
  }

  public cardTitleMedia(): MediaRefFragment | RibbonMedia[] | undefined | null {
    return (
      (
        (this.fragment.details?.integration as unknown as ProductHuntPromoInteractionDetails)?.post
          ?.media as ProductHuntMedia[] | undefined
      )?.filter((m) => m.type === 'image') ?? []
    );
  }

  public cardComponent(): React.FC<{ onClickHeader?: () => void }> {
    return ProductHuntPromoCard;
  }

  public cardBodyComponent(): React.FC {
    return NoBodyCard;
  }

  public modalValidationRules(): Record<string, yup.Schema<unknown>> {
    return ProductHuntPromoInteractionValidationRules();
  }

  public modalTitleComponent(): React.FC<InteractionModalTitleProps> {
    return ProductHuntPromoInteractionModalTitle;
  }

  public useModalPreviewComponent(): React.LazyExoticComponent<
    React.FC<InteractionModalComponentProps>
  > | null {
    return ProductHuntPromoInteractionModal;
  }

  public modalSettingsAccordions(): InteractionModalAccordionsHook {
    return useProductHuntPromoInteractionModalSettings;
  }

  public canSubmitMuktipleTimes(): boolean {
    return true;
  }

  public analyticsCardComponent(): React.LazyExoticComponent<React.FC<AnalyticsCardProps>> {
    return AnalyticsClickCard;
  }
}
